import { HelpOutlineOutlined } from '@mui/icons-material';
import { NavListItem, NavListItemToolTipContent } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';
import { useIntercom } from 'react-use-intercom';

import { useConfig } from '~/components/ConfigProvider';
import { mailToLink } from '~/util/string';

export const NavListItemSupport = () => {
  const { t } = useTranslation();
  const { supportEmail, intercom } = useConfig();
  const { show } = useIntercom();

  const supportLink = mailToLink(supportEmail, t('Support.mailto.subject'), t('Support.mailto.body'));

  return (
    <NavListItem
      {...(intercom.enabled ? { onClick: show } : { component: 'a', href: supportLink })}
      tooltip={<NavListItemToolTipContent label={t('Nav.support')} />}
    >
      <HelpOutlineOutlined />
    </NavListItem>
  );
};
